/**
 * Default chart configurations for different chart types
 * These provide sensible defaults for styling, colors, responsiveness, and chart-specific options
 */
export const DEFAULT_CHART_CONFIGS = {
  line: {
    options: {
      responsive: true,
      maintainAspectRatio: true,
      aspectRatio: 2,
      plugins: {
        legend: {
          position: "top" as const
        },
        title: {
          display: false
        }
      },
      scales: {
        x: {
          grid: {
            display: true
          }
        },
        y: {
          beginAtZero: true,
          grid: {
            display: true
          }
        }
      }
    },
    datasetDefaults: {
      fill: false,
      tension: 0.4,
      pointRadius: 4,
      pointHoverRadius: 6,
      borderWidth: 2
    }
  },
  bar: {
    options: {
      responsive: true,
      maintainAspectRatio: true,
      aspectRatio: 2,
      plugins: {
        legend: {
          position: "top" as const
        },
        title: {
          display: false
        }
      },
      scales: {
        x: {
          grid: {
            display: false
          }
        },
        y: {
          beginAtZero: true,
          grid: {
            display: true
          }
        }
      }
    },
    datasetDefaults: {
      borderWidth: 1,
      borderRadius: 4
    }
  },
  pie: {
    options: {
      responsive: true,
      maintainAspectRatio: true,
      aspectRatio: 2,
      plugins: {
        legend: {
          position: "right" as const
        },
        title: {
          display: true
        }
      }
    },
    datasetDefaults: {
      borderWidth: 2
    }
  },
  doughnut: {
    options: {
      responsive: true,
      maintainAspectRatio: true,
      aspectRatio: 2,
      plugins: {
        legend: {
          position: "right" as const
        },
        title: {
          display: false
        }
      }
    },
    datasetDefaults: {
      borderWidth: 2
    }
  },
  radar: {
    options: {
      responsive: true,
      maintainAspectRatio: true,
      aspectRatio: 2,
      plugins: {
        legend: {
          position: "top" as const
        },
        title: {
          display: false
        }
      }
    },
    datasetDefaults: {
      borderWidth: 2,
      pointRadius: 3,
      pointHoverRadius: 5
    }
  },
  polarArea: {
    options: {
      responsive: true,
      maintainAspectRatio: true,
      aspectRatio: 2,
      plugins: {
        legend: {
          position: "right" as const
        },
        title: {
          display: false
        }
      }
    },
    datasetDefaults: {
      borderWidth: 2
    }
  },
  scatter: {
    options: {
      responsive: true,
      maintainAspectRatio: true,
      aspectRatio: 2,
      plugins: {
        legend: {
          position: "top" as const
        },
        title: {
          display: false
        }
      },
      scales: {
        x: {
          type: "linear" as const,
          position: "bottom" as const
        },
        y: {
          beginAtZero: true
        }
      }
    },
    datasetDefaults: {
      pointRadius: 5,
      pointHoverRadius: 7
    }
  }
};

/**
 * Default color palette for datasets
 * Professional color scheme with good contrast and accessibility
 */
export const DEFAULT_COLORS = [
  {
    borderColor: "rgba(75, 192, 192, 1)",
    backgroundColor: "rgba(75, 192, 192, 0.2)"
  },
  {
    borderColor: "rgba(255, 99, 132, 1)",
    backgroundColor: "rgba(255, 99, 132, 0.2)"
  },
  {
    borderColor: "rgba(54, 162, 235, 1)",
    backgroundColor: "rgba(54, 162, 235, 0.2)"
  },
  {
    borderColor: "rgba(255, 206, 86, 1)",
    backgroundColor: "rgba(255, 206, 86, 0.2)"
  },
  {
    borderColor: "rgba(153, 102, 255, 1)",
    backgroundColor: "rgba(153, 102, 255, 0.2)"
  },
  {
    borderColor: "rgba(255, 159, 64, 1)",
    backgroundColor: "rgba(255, 159, 64, 0.2)"
  }
];
